import axios from "axios";

export function fetchUsersAction(bid) {
    return {
        type: 'FETCH_USERS',
        meta: {
            bid: bid
        },
        payload: async () => {
            const users_resp = await axios.get('/api/v2a/getUsers', {params: {bid}});

            return users_resp.data;
        }
    };
}

export function deleteUserAction(uid) {
    return {
        type: "DELETE_USER",
        meta: {"uid": uid},
        payload: axios.post('/api/v2a/deleteUser', {uid})
    };
}

export function addUserAction(user) {
    return {
        type: "ADD_USER",
        meta: user,
        payload: axios.post('/api/v2a/saveUser', user)
    };
}

export function editUserAction(user) {
    return {
        type: "EDIT_USER",
        meta: user,
        payload: axios.post('/api/v2a/saveUser', user)
    };
}